import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import {
    MonitoringSheetGridObject,
    MonitoringSheetObject,
} from '@libs/types/src/services/object-type/service/monitoring-sheet.object';
import { MonitoringSheetCreateInput } from '@libs/types/src/services/input-type/services/monitoring-sheet.create-input';
import { MonitoringSheetUpdateInput } from '@libs/types/src/services/input-type/services/monitoring-sheet.update-input';
import { filterFrag } from './types/filter.types';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';

@Injectable({ providedIn: 'root' })
export class MonitoringSheetGqlService extends GqlServiceV2 {

    public getMonitoringSheets(input: GridInput | null, frag: string) {
        return this.query<MonitoringSheetGridObject>(
            `
                query($input: GridInput) {
                    monitoringSheet {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createMonitoringSheet(input: MonitoringSheetCreateInput) {
        return this.mutate<MonitoringSheetObject>(
            `
                mutation($input: MonitoringSheetCreateInput!) {
                    monitoringSheet {
                        create(input: $input) {
                            id
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateMonitoringSheet(input: MonitoringSheetUpdateInput) {
        return this.mutate<MonitoringSheetObject>(
            `
                mutation($input: MonitoringSheetUpdateInput!) {
                    monitoringSheet {
                        update(input: $input) {
                            id
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteMonitoringSheet(input: IdInput) {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    monitoringSheet {
                        delete(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }
}
